/** Ключ виджета View */
const VIEW_WIDGET_KEY = 'View';
/** Типы команд для ViewWidget */
var ViewCmdType;
(function (ViewCmdType) {
    /** Перезагрузка содержимого view */
    ViewCmdType["reload"] = "reload";
    /** Обновление view с сохранением значений в полях ввода */
    ViewCmdType["refresh"] = "refresh";
    ViewCmdType["viewstartedit"] = "viewstartedit";
    ViewCmdType["saveview"] = "saveview";
    ViewCmdType["insertview"] = "insertview";
    ViewCmdType["itemcmd"] = "itemcmd";
    ViewCmdType["asyncprocess"] = "asyncprocess";
    ViewCmdType["onchange"] = "onchange";
})(ViewCmdType || (ViewCmdType = {}));

export { VIEW_WIDGET_KEY, ViewCmdType };
